import React from 'react';
import ApiLayout from '@/components/ApiLayout';

const DocumentationPage: React.FC = () => {
  return (
    <ApiLayout>
<div className="container mx-auto px-4 py-8">
<h1 className="text-3xl font-bold mb-4">Education pins Endpoint</h1>

<section className="mb-8">
  <h2 className="text-xl font-semibold mb-2">Endpoint</h2>
  <p>URL: <code>/api/eduapi</code></p>
  <p>Methods: <code>POST</code>, <code>GET</code></p>
</section>

<section className="mb-8">
  <h2 className="text-xl font-semibold mb-2">Description</h2>
  <p>This API endpoint allows users to purchase education pins like waec, neco, etc.</p>
</section>

<section className="mb-8">
  <h2 className="text-xl font-semibold mb-2">Authentication</h2>
  <p>To access this endpoint, users must include their API key and secret key in the request headers.</p>
</section>

<section className="mb-8">
  <h2 className="text-xl font-semibold mb-2">Request Headers</h2>
  <ul>
    <li><strong>api-key</strong> (string, required): The API key of the user.</li>
    <li><strong>secret-key</strong> (string, required): The secret key of the user.</li>
  </ul>
</section>

<section className="mb-8">
  <h2 className="text-xl font-semibold mb-2">Request Body (POST)</h2>
  <ul>
    <li><strong>phone</strong> (string, required): The phone number of the recipient.</li>
    <li><strong>firstLevel</strong> (string, required): The name of the examination.</li>
    <li><strong>secondLevel</strong> (string, required): The type of the examination pin.</li>
    <li><strong>phone</strong> (string, optional): The phone exam number of the recipient, if applicable.</li>
  </ul>
</section>

<section className="mb-8">
  <h2 className="text-xl font-semibold mb-2">Usage Example</h2>
  <p>See usage example in the code snippets below:</p>
  <div className="bg-gray text-black-100 p-4 rounded-md">
    <h3 className="text-lg font-semibold mb-2">Example: Purchase Education pins</h3>
    <p>POST request to purchase education pins:</p>
    <pre className="bg-gray-200 text-black p-2 rounded-md overflow-x-auto">
      {`
Content-Type: application/json
api-key: your-api-key
secret-key: your-secret-key

{
"phone": "08032566178",
"firstLevel": "NECO",
"secondLevel": "Resut checker",
}
      `}
    </pre>
    <p>Response:</p>
    <pre className="bg-gray-200 text-black p-2 rounded-md overflow-x-auto">
      {`
- Status Code: 200

{
    "message": "Transaction successful",
    "eduHistory": {
        "email": "user@example.com",
        "transactionId": "202403021250s56bxh3mz5",
        "activity": "NECO",
        "message": "Resut checker",
        "status": "Success",
        "recipient": "08032566178",
        "number": 52665324546565,
        "token": "555555123355533",
        "amount": 10000,
        "initialBalance": 1264,
        "finalBalance": 264,
        "Method": "API",
    }
}
      `}
    </pre>
  </div>
</section>

<section className="mb-8">
  <h2 className="text-xl font-semibold mb-2">Failed Response Format</h2>
  <pre className="bg-gray-100 text-black p-4 rounded-md overflow-x-auto">
    {`

{
    "error": "Transaction failed",
    "eduHistory": {
        "email": "user@example.com",
        "transactionId": "202403021259avdzv2xt2c9",
        "activity": "NECO",
        "message": "Resut checker",
        "status": "Failed",
        "recipient": "08032566178",
        "number": 52665324546565,
        "amount": 1000,
        "initialBalance": 1167,
        "finalBalance": 1167,
        "Method": "API",
    }
}
    `}
  </pre>
</section>

<section className="mb-8">
  <h2 className="text-xl font-semibold mb-2">GET request</h2>
  <p>See usage example in the code snippets below:</p>
  <div className="bg-gray-100 text-black p-4 rounded-md">
    <h3 className="text-lg font-semibold mb-2">Get the list of available firstLevel</h3>
    <p>GET request for available firstLevel:</p>
    <pre className="bg-gray-200 p-2 rounded-md overflow-x-auto">
      {`
Content-Type: application/json
api-key: your-api-key
secret-key: your-secret-key

      `}
    </pre>
    <p>Response:</p>
    <pre className="bg-gray-200 p-2 rounded-md overflow-x-auto">
      {`
- Status Code: 200

[
    {
        "firstLevel": "NECO",
        "secondevel": "Result checker",
        "amount": 1000
    },
    {
        "firstLevel": "WAEC",
        "secondevel": "Exam pin",
        "amount": 1000
    }
]
            `}
    </pre>
  </div>
</section>

<section className="mb-8">
  <h2 className="text-xl font-semibold mb-2">Other Error Responses</h2>
  <ul>
    <li><strong>401 Unauthorized</strong>: Invalid API key or secret key.</li>
    <li><strong>404 Not Found</strong>: User not found or data not available.</li>
    <li><strong>500 Internal Server Error</strong>: Internal server error occurred.</li>
  </ul>
</section>

</div>
    </ApiLayout>
  );
};

export default DocumentationPage;
